import { Stack, Text } from '@chakra-ui/react'
import { uniqueId } from 'lodash'
import React from 'react'

interface JointOwnerTaxIdsProps {
  receivingSecondaryTaxIds: string[]
}

const JointOwnerTaxIds = ({
  receivingSecondaryTaxIds,
}: JointOwnerTaxIdsProps) => (
  <Stack direction="column" spacing={4}>
    {receivingSecondaryTaxIds.map(receivingSecondaryTaxId => (
      <Text key={uniqueId(receivingSecondaryTaxId)}>
        {receivingSecondaryTaxId}
      </Text>
    ))}
  </Stack>
)

export default JointOwnerTaxIds
